import service, { type HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export const getDemandReport = (
	query: any
): Promise<HttpResponseSuccess<unknown>> =>
	apiService.post('/api/location/createDemandReport', query);

export const getDemandReports = (
	query: any
): Promise<HttpResponseSuccess<unknown>> =>
	apiService.post('api/location/getDemandReport', query);
